/**
 * Twilo JS File
 * @author Twilo Creative
 */

// Modules
import * as bootstrap from "./modules/bootstrap.5.3.2.bundle.js";
window.bootstrap = bootstrap;

// Site-specific JS
import "./core/accordion.js";
import "./custom.js";

